module.exports = __webpack_public_path__ + "img/MES4Indice2_cutout.e74dc8a3.png";